<template>
    <div>
        <div class="flex flex-wrap gap-2" :class="{'mb-2': selectedHabitants.length}">
            <div
                v-for="habitant in selectedHabitants"
                :key="habitant.uuid"
                class="inline-flex items-center pl-1 pr-2 py-1 rounded-full bg-indigo-100 dark:bg-indigo-500/20"
            >
                <span
                    v-if="habitant.data.locataire.initials"
                    class="rounded-full flex items-center justify-center w-6 h-6 text-white text-xs"
                    :class="`bg-${habitant.data.locataire.color}`"
                >
                    {{ habitant.data.locataire.initials }}
                </span>
                <span class="px-2 text-sm text-indigo-700 dark:text-indigo-300">
                    {{ habitant.data.locataire.prenom }} {{ habitant.data.locataire.nom }}
                </span>
                <button
                    type="button"
                    class="text-indigo-400 hover:text-red-500 dark:text-indigo-400 dark:hover:text-red-400"
                    @click="deselect(habitant)"
                >
                    <font-awesome-icon :icon="['fa', 'times']" />
                </button>
            </div>
        </div>
        <p v-if="!selectedHabitants.length" class="text-sm text-gray-400 dark:text-gray-500 italic mb-2">
            Aucun locataire sélectionné
        </p>

        <div v-if="availableHabitants.length">
            <label class="form-label mb-0 text-xs">Autres locataires du bien</label>
            <div class="flex flex-wrap gap-2 mt-1">
                <button
                    type="button"
                    v-for="habitant in availableHabitants"
                    :key="habitant.uuid"
                    class="inline-flex items-center pl-1 pr-2 py-1 rounded-full bg-gray-100 dark:bg-gray-700 border border-dashed border-gray-300 dark:border-gray-600 hover:border-indigo-400 dark:hover:border-indigo-500 hover:bg-indigo-50 dark:hover:bg-gray-600"
                    @click="select(habitant)"
                >
                    <span
                        v-if="habitant.data.locataire.initials"
                        class="rounded-full flex items-center justify-center w-6 h-6 text-white text-xs opacity-60"
                        :class="`bg-${habitant.data.locataire.color}`"
                    >
                        {{ habitant.data.locataire.initials }}
                    </span>
                    <span class="px-2 text-sm text-gray-500 dark:text-gray-400">
                        {{ habitant.data.locataire.prenom }} {{ habitant.data.locataire.nom }}
                    </span>
                    <font-awesome-icon :icon="['fa', 'plus']" class="text-gray-400" />
                </button>
            </div>
        </div>
    </div>
</template>

<script>
    export default {
        data() {
            return {
                habitants: [],
            }
        },
        props: {
            modelValue: {
                type: Array,
                default: () => []
            },
        },
        created() {
            this.habitants = this.modelValue
        },
        computed: {
            selectedHabitants() {
                return this.habitants.filter(h => h.selected)
            },
            availableHabitants() {
                return this.habitants.filter(h => !h.selected)
            },
        },
        methods: {
            select(habitant) {
                habitant.selected = 1
                this.$emit('update', this.habitants)
            },
            deselect(habitant) {
                habitant.selected = 0
                this.$emit('update', this.habitants)
            },
        },
    };
</script>
